import type { MantineTheme, MantineThemeOverride } from "@mantine/core"
import { components } from "./components"

export const theme: MantineThemeOverride = {
  breakpoints: {
    xs: "36em",
    sm: "48em",
    md: "62em",
    lg: "75em",
    xl: "88em",
  },
  components,
  defaultRadius: "md",
}

export const cssVariablesResolver = (theme: MantineTheme) => ({
  variables: {},
  light: {
    "--mantine-color-panel": theme.colors.gray[2],
  },
  dark: {
    "--mantine-color-panel": theme.colors.dark[6],
  },
})
